import React from "react"
import { Link } from "gatsby"
import { Container, StLogo } from "./Header.css"
import LogoAlemana from "../../images/logo-alemana-sport.svg"
import {
  LaboratorioDeContenidosDeMarcaWhite,
  LaterceraWhite,
} from "copesa-logos"

const Header = () => (
  <Container>
    <Link to="/" className="slotLab">
      <StLogo>
        <LaterceraWhite />
      </StLogo>
    </Link>
    <Link to="/" className="slotSponsor">
      <StLogo className="slotSponsorLogo">
        <span>Presentado por</span>
        <img src={LogoAlemana} alt="Alemana Sport" />
      </StLogo>
    </Link>
    <Link to="/" className="slotLT">
      <StLogo>
        <LaboratorioDeContenidosDeMarcaWhite />
      </StLogo>
    </Link>
  </Container>
)

export default Header
